// Shared full-page shell: neutral background, logo, content slot, footer (matches email auth pages)
import React, { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import { APP_NAME } from '../../helpers/constants';
import { useTheme } from '../../contexts/ThemeContext';

interface AuthBrandedLayoutProps {
  children: ReactNode;
}

const AuthBrandedLayout: React.FC<AuthBrandedLayoutProps> = ({ children }) => {
  const { isDarkMode } = useTheme();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'background.default',
        p: 2,
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
        <Box
          component="img"
          src={isDarkMode ? '/fulllogo-white.png' : '/fulllogo.png'}
          alt={APP_NAME}
          sx={{
            height: 48,
            width: 'auto',
            maxWidth: '100%',
            objectFit: 'contain',
          }}
        />
      </Box>

      {children}

      <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 3 }}>
        © {new Date().getFullYear()} {APP_NAME}. All rights reserved.
      </Typography>
    </Box>
  );
};

export default AuthBrandedLayout;
